import { call, put } from 'redux-saga/effects';
import * as api from '../services/api';
import { load, loaded } from '../ducks/loading';
import { toastify } from '../ducks/toast';
import { setFlow } from '../ducks/flow';

//call the API with the global loading bar; never throws
export function* request(method, url, body, opts = {}) {
  if (!opts.silent) yield put(load());
  try {
    const res = yield call(method === 'GET' ? api.GET : api.POST, url, body);
    return res || { status: 'error', m: 'Something went wrong. Please try again.' };
  } catch (e) {
    return { status: 'error', m: 'Something went wrong. Please try again.' };
  } finally {
    if (!opts.silent) yield put(loaded());
  }
}

//toast the result message and publish a flow result for the page
export function* finish(name, res, { toastSuccess = true, toastError = true } = {}) {
  const ok = res && res.status === 'success';
  if (res && res.status === 'Unauthorized') return ok; //api.js already redirects to login
  if (ok && toastSuccess && res.m) yield put(toastify({ type: 'success', msg: res.m }));
  if (!ok && toastError) yield put(toastify({ type: 'error', msg: (res && res.m) || 'Something went wrong. Please try again.' }));
  yield put(setFlow({ name, ok, m: res && res.m, data: res && res.data }));
  return ok;
}
